package com.hyperether.goodjob.scenes.addNew

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import com.hyperether.goodjob.addItemMargin
import com.hyperether.goodjob.boxCornerShape
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp

@Composable
fun AddNewHeader(
    titleText: String,
    showDelete: Boolean,
    deleteText: String,
    onDelete: () -> Unit,
    content: @Composable () -> Unit
) {
    Column(
        modifier = Modifier.fillMaxSize()
            .padding(start = 75.toScaleDp(), end = 75.toScaleDp(), top = 15.toScaleDp())
            .border(width = 1.toScaleDp(), color = BorderColor, shape = boxCornerShape())
            .background(color = Color.White, shape = boxCornerShape())
    ) {
        Row(
            modifier = Modifier.fillMaxWidth()
                .padding(top = addItemMargin(), start = addItemMargin(), end = addItemMargin()),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = titleText,
                color = Color.Black,
                fontSize = 24.toScaleSp(),
                fontWeight = FontWeight.Bold
            )

            if (showDelete) {
                Spacer(modifier = Modifier.weight(1f))
                DisableSelection {
                    Text(
                        text = deleteText,
                        color = Color.Red,
                        fontSize = 18.toScaleSp(),
                        modifier = Modifier
                            .clickableWithPointer {
                                onDelete()
                            },
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
            }
        }

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .fillMaxHeight()
                .background(color = Color.White)
                .padding(addItemMargin())
        ) {
            content()
        }
    }
}